import __ from "src/utils/Translations";
import { useCallback, ReactNode } from "react";

interface IUseUnsavedChangesGuard {
  onExit: () => void;
  onCancel?: () => void;
  setModal: (modal: any) => void;
  resetModal: () => void;
  title?: ReactNode;
  description?: string;
  continueLabel?: string;
  exitLabel?: string;
}

const useUnsavedChangesGuard = ({
  onExit,
  onCancel,
  setModal,
  resetModal,
  title = __("Czy na pewno chcesz opuścić formularz?"),
  description = __("Opuszczenie formularza spowoduje utratę wszystkich niezapisanych danych. Czy na pewno chcesz kontynuować?"),
  continueLabel = __("Kontynuuj edytowanie"),
  exitLabel = __("Wyjdź"),
}: IUseUnsavedChangesGuard) =>
  useCallback(() => {
    setModal({
      open: true,
      title,
      description,
      actions: [
        {
          label: continueLabel,
          variant: "outlined",
          callbackFn: () => {
            if (onCancel) onCancel();
            resetModal();
          },
        },
        {
          label: exitLabel,
          variant: "contained",
          color: "error",
          callbackFn: () => {
            onExit();
            resetModal();
          },
        },
      ],
    });
  }, [
    onExit,
    onCancel,
    setModal,
    resetModal,
    title,
    description,
    continueLabel,
    exitLabel,
  ]);

export default useUnsavedChangesGuard;
